module.exports = __webpack_public_path__ + "img/slideshow5.c418ce04.jpg";